<template>
    <svg width="12px" height="7px" viewBox="0 0 12 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="design_Mapa_nośników" transform="translate(-800.000000, -315.000000)" fill="#B2B2B2">
                <g id="google_maps_search" transform="translate(310.000000, 293.000000)">
                    <g id="Group-2" transform="translate(373.000000, 0.000000)">
                        <g id="Icons/Form_Arrow_down_ico" transform="translate(117.500000, 22.000000)">
                            <polygon id="Icon/Form_Arrow_down_ico" points="1.999943 1.999991 9.999935 1.999991 5.999994 5.999938"></polygon>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "OpenIndicator"
}
</script>

<style scoped>

</style>
